
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SettingsTab from '@/components/admin/SettingsTab';
import { useAuth } from '@/context/AuthContext';

const Settings = () => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow flex items-center justify-center">
          <p>Veuillez vous connecter pour accéder aux paramètres.</p>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-8">Paramètres</h1>
          
          <SettingsTab />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Settings;
